export default __webpack_public_path__ + "static/media/adLogo.aac7d465.png";